
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class CompanyDialog extends Serenity.EntityDialog<CompanyRow, any> {
        protected getFormKey() { return CompanyForm.formKey; }
        protected getIdProperty() { return CompanyRow.idProperty; }
        protected getLocalTextPrefix() { return CompanyRow.localTextPrefix; }
        protected getNameProperty() { return CompanyRow.nameProperty; }
        protected getService() { return CompanyService.baseUrl; }
        protected getInsertPermission() { return CompanyRow.insertPermission; }
        protected getUpdatePermission() { return CompanyRow.updatePermission; }
        protected getDeletePermission() { return CompanyRow.deletePermission; }
        protected useViewMode() { return true; }

        protected form = new CompanyForm(this.idPrefix);
        constructor() {
            super();

            q.hideCategorylinks(this.element);

            Serenity.EditorUtils.setReadOnly(this.form.State, true);
            this.form.Country.changeSelect2(e => {
                this.form.State.cascadeField = "CountryId";
                this.form.State.cascadeValue = this.form.Country.value;
                Serenity.EditorUtils.setReadOnly(this.form.State, false);

            });
            this.form.TypeOfCompany.changeSelect2(e => {
                if (this.form.TypeOfCompany.value == "Parent") {
                    this.form.ParentCompany.value = "0";
                    Serenity.EditorUtils.setReadOnly(this.form.ParentCompany, true);
                } else if (this.form.TypeOfCompany.value == "Branch") {
                    
                    Serenity.EditorUtils.setReadOnly(this.form.ParentCompany, false);
                }

            })
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.TypeOfCompany.value == "Parent") {
                this.form.ParentCompany.value = "0";
                Serenity.EditorUtils.setReadOnly(this.form.ParentCompany, true);
            } else if (this.form.TypeOfCompany.value == "Branch") {

                Serenity.EditorUtils.setReadOnly(this.form.ParentCompany, false);
            }

        }


    }
}